if (document.body.dataset.gender != '') {
    localStorage.setItem('selectedGender', document.body.dataset.gender);
}

document.addEventListener("DOMContentLoaded", function () {
    const wrappers = document.querySelectorAll('.mega-menu__wrapper');
    wrappers.forEach(wrapper => {
        const items = wrapper.querySelectorAll('.mega-menu__item');
        let maxOrder = -Infinity;
        let maxOrderItem = null;

        items.forEach(item => {
            const order = parseInt(getComputedStyle(item).order);
            if (order > maxOrder) {
                maxOrder = order;
                maxOrderItem = item;
            }
        });

        if (maxOrderItem) {
            maxOrderItem.style.borderRight = 'none';
        }
    });
});

// Mobile header menu
const mobileMegaMenuItem = document.querySelectorAll('.mobile-mega-menu__main-item');
const drawerContent = document.querySelector('.drawer__content');
const drawerBodySublink = document.querySelector('.drawer__body__sublink');

mobileMegaMenuItem.forEach(el => {
    el.addEventListener('click', () => {
        // Check if this is a hardcoded Home button
        const homeUrl = el.getAttribute('data-home-url');
        if (homeUrl) {
            window.location.href = homeUrl;
            return; // Exit early, redirect directly
        }

        // Regular menu item behavior - show submenu
        const dataLink = el.getAttribute('data-link');
        const targetElement = document.querySelector(`[data-menu="${dataLink}"]`);

        if (targetElement) {
            drawerContent.classList.toggle("drawer__content--hidden");
            drawerBodySublink.classList.toggle("drawer__body__sublink--active");

            // Remove active class from all elements
            document.querySelectorAll('.mega-menu-mobile__wrapper--active')
                .forEach(activeEl => activeEl.classList.remove('mega-menu-mobile__wrapper--active'));

            // Add active class to the target element
            targetElement.classList.add('mega-menu-mobile__wrapper--active');
        }
    });
});


const mobileArrowBack = document.querySelectorAll('.menu-mobile-arrow__back');

mobileArrowBack.forEach(el => {
    el.addEventListener('click', (event) => {
        drawerContent.classList.toggle("drawer__content--hidden");
        drawerBodySublink.classList.toggle("drawer__body__sublink--active");

        event.target.closest('.mega-menu-mobile__wrapper').classList.remove('mega-menu-mobile__wrapper--active');
    });
});


// Save gender
document.addEventListener("DOMContentLoaded", function () {
    const genderLinks = document.querySelectorAll('.header__desktop .header-gender-menu a');

    genderLinks.forEach(link => {
        link.addEventListener('click', event => {
            const gender = link.getAttribute('data-gender');

            // Save to localStorage
            localStorage.setItem('selectedGender', gender);
            console.log(`Saved gender: ${gender}`);

            // Clear all active states - desktop
            document.querySelectorAll('.header__desktop .header-gender-menu a').forEach(el => {
                el.classList.remove('header__active-menu-item');
            });

            // Clear all active states - mobile drawer
            document.querySelectorAll('.drawer-content__gender').forEach(el => {
                el.classList.remove('drawer-content__gender-menu-item--active');
            });

            // Set clicked desktop tab as active
            link.classList.add('header__active-menu-item');

            // Set corresponding mobile tab as active
            const mobileTab = document.querySelector(`li[data-mobile-menu="${gender}"]`);
            if (mobileTab) {
                mobileTab.classList.add('drawer-content__gender-menu-item--active');
            }

            // Hide all desktop mega menus
            document.querySelectorAll('.custom-mega-menu').forEach(menu => {
                menu.classList.add('custom-mega-menu--hidden');
            });

            // Show the selected desktop mega menu
            const desktopMenu = document.querySelector(`.custom-mega-menu--${gender}`);
            if (desktopMenu) {
                desktopMenu.classList.remove('custom-mega-menu--hidden');
            }

            // Hide all mobile mega menus
            document.querySelectorAll('.mobile-mega-menu').forEach(menu => {
                menu.classList.add('custom-mega-menu--hidden');
            });

            // Show the selected mobile mega menu
            const mobileMenu = document.querySelector(`.mobile-mega-menu--${gender}`);
            if (mobileMenu) {
                mobileMenu.classList.remove('custom-mega-menu--hidden');
            }
        });
    });

    // Note: Mobile drawer clicks are handled by .drawer-content__gender selector below

    const savedGender = localStorage.getItem('selectedGender');

    // Simple initialization - if there's a saved gender, activate it
    if (savedGender) {
        // Clear all active states first
        document.querySelectorAll('.header__active-menu-item').forEach(el => {
            el.classList.remove('header__active-menu-item');
        });
        document.querySelectorAll('.drawer-content__gender-menu-item--active').forEach(el => {
            el.classList.remove('drawer-content__gender-menu-item--active');
        });

        // Hide all menus first
        document.querySelectorAll('.custom-mega-menu').forEach(menu => {
            menu.classList.add('custom-mega-menu--hidden');
        });
        document.querySelectorAll('.mobile-mega-menu').forEach(menu => {
            menu.classList.add('custom-mega-menu--hidden');
        });

        // Activate the saved gender
        const activeLink = document.querySelector(`.header__desktop .header-gender-menu a[data-gender="${savedGender}"]`);
        const activeSubMenu = document.querySelector(`.custom-mega-menu--${savedGender}`);
        const activeLinkMobile = document.querySelector(`li[data-mobile-menu="${savedGender}"]`);
        const activeSubMenuMobile = document.querySelector(`.mobile-mega-menu--${savedGender}`);

        if (activeLink) activeLink.classList.add('header__active-menu-item');
        if (activeSubMenu) activeSubMenu.classList.remove('custom-mega-menu--hidden');
        if (activeLinkMobile) activeLinkMobile.classList.add('drawer-content__gender-menu-item--active');
        if (activeSubMenuMobile) activeSubMenuMobile.classList.remove('custom-mega-menu--hidden');
    }

    const drawerContentGender = document.querySelectorAll('.drawer-content__gender');
    const mobileMegaMenu = document.querySelectorAll('.mobile-mega-menu');

    drawerContentGender.forEach(element => {
        element.addEventListener('click', (event) => {
            const listItem = event.target.closest('.drawer-content__gender');
            const mobileMenuValue = listItem.getAttribute('data-mobile-menu');
            const gender = listItem.getAttribute('data-gender');

            // Remove active class from all gender tabs
            drawerContentGender.forEach(el => {
                el.classList.remove('drawer-content__gender-menu-item--active');
            });

            // Add active class to clicked tab
            listItem.classList.add('drawer-content__gender-menu-item--active');

            // Save to localStorage
            localStorage.setItem('selectedGender', gender);
            console.log(`Saved gender: ${gender}`);

            // Hide all mobile mega menus
            mobileMegaMenu.forEach(item => {
                item.classList.add('custom-mega-menu--hidden');
            });

            // Show the selected mobile mega menu
            const mobileMegaMenuItem = document.querySelector(`.mobile-mega-menu--${mobileMenuValue}`);
            if (mobileMegaMenuItem) {
                mobileMegaMenuItem.classList.remove('custom-mega-menu--hidden');
            }

            // Also update desktop menu state
            document.querySelectorAll('.header__active-menu-item').forEach(el => {
                el.classList.remove('header__active-menu-item');
            });

            const desktopLink = document.querySelector(`.header__desktop .header-gender-menu a[data-gender="${gender}"]`);
            if (desktopLink) {
                desktopLink.classList.add('header__active-menu-item');
            }

            // Hide all desktop menus and show the selected one
            document.querySelectorAll('.custom-mega-menu').forEach(menu => {
                menu.classList.add('custom-mega-menu--hidden');
            });

            const desktopMenu = document.querySelector(`.custom-mega-menu--${gender}`);
            if (desktopMenu) {
                desktopMenu.classList.remove('custom-mega-menu--hidden');
            }
        });
    });
});

// Collection Sub Gallery - Optimized with debouncing and passive listeners
;(function() {
  'use strict';
  
  // Debounce utility for performance
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  
  // Throttle utility for scroll events
  function throttle(func, limit) {
    let inThrottle;
    return function(...args) {
      if (!inThrottle) {
        func.apply(this, args);
        inThrottle = true;
        setTimeout(() => inThrottle = false, limit);
      }
    };
  }
  
  function initSubcategoryGallery(wrapper) {
    const container = wrapper.querySelector('[data-gallery-container]');
    const prevBtn = wrapper.querySelector('[data-gallery-prev]');
    const nextBtn = wrapper.querySelector('[data-gallery-next]');
    
    if (!container || !prevBtn || !nextBtn) return;
    
    // Cache item width calculation
    let itemWidth = null;
    let gap = 15;
    
    function getItemWidth() {
      if (itemWidth === null) {
        const firstItem = container.querySelector('.subcategory-gallery__item');
        itemWidth = firstItem?.offsetWidth || 140;
        gap = parseInt(getComputedStyle(container).gap) || 15;
      }
      return { itemWidth, gap };
    }
    
    function updateButtons() {
      const scrollLeft = container.scrollLeft;
      const scrollWidth = container.scrollWidth;
      const clientWidth = container.clientWidth;
      const scrollThreshold = 1; // Small threshold for floating point issues
      
      const isAtStart = scrollLeft <= scrollThreshold;
      const isAtEnd = scrollLeft >= scrollWidth - clientWidth - scrollThreshold;
      const allItemsFit = scrollWidth <= clientWidth;
      
      prevBtn.disabled = isAtStart;
      nextBtn.disabled = isAtEnd;
      
      // Center gallery if all items fit
      if (allItemsFit) {
        container.style.justifyContent = 'center';
        prevBtn.style.opacity = '0';
        nextBtn.style.opacity = '0';
        prevBtn.style.pointerEvents = 'none';
        nextBtn.style.pointerEvents = 'none';
      } else {
        container.style.justifyContent = 'flex-start';
        prevBtn.style.opacity = '1';
        nextBtn.style.opacity = '1';
        prevBtn.style.pointerEvents = 'auto';
        nextBtn.style.pointerEvents = 'auto';
      }
    }
    
    function scrollGallery(direction) {
      const { itemWidth: width, gap: spacing } = getItemWidth();
      const scrollAmount = (width + spacing) * 2; // Scroll by 2 items
      
      if (direction === 'prev') {
        container.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      } else {
        container.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      }
    }
    
    // Use passive listeners for better scroll performance
    const throttledUpdate = throttle(updateButtons, 100);
    container.addEventListener('scroll', throttledUpdate, { passive: true });
    
    // Button click handlers - store references for cleanup if needed
    const prevHandler = () => scrollGallery('prev');
    const nextHandler = () => scrollGallery('next');
    prevBtn.addEventListener('click', prevHandler, { passive: true });
    nextBtn.addEventListener('click', nextHandler, { passive: true });
    
    // Debounced resize handler - reset cached width on resize
    const handleResize = debounce(() => {
      itemWidth = null; // Reset cache on resize
      updateButtons();
    }, 150);
    
    window.addEventListener('resize', handleResize, { passive: true });
    
    // Initial button state - use requestAnimationFrame for better performance
    requestAnimationFrame(updateButtons);
    
    // Cleanup function (if needed for dynamic content)
    return function cleanup() {
      container.removeEventListener('scroll', throttledUpdate);
      window.removeEventListener('resize', handleResize);
      prevBtn.removeEventListener('click', prevHandler);
      nextBtn.removeEventListener('click', nextHandler);
    };
  }
  
  // Initialize galleries on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      const galleries = document.querySelectorAll('.subcategory-gallery__wrapper');
      galleries.forEach(initSubcategoryGallery);
    });
  } else {
    // DOM already loaded
    const galleries = document.querySelectorAll('.subcategory-gallery__wrapper');
    galleries.forEach(initSubcategoryGallery);
  }
})();


/**
 * Swatch tap-preview (mobile) + click-navigate (desktop)
 * Added: 2026-04-23
 *
 * Replaces the earlier "Sibling swatch click navigation fix" (which only
 * stopPropagation'd so the theme's duplicate click-forward wouldn't break
 * navigation). This extends it with a proper touch-tap preview pattern.
 *
 * Behavior:
 *   Touch devices
 *     Tap on a color swatch = preview ONLY, always:
 *       - Swaps the card's main thumbnail to that color
 *       - Marks the swatch as .is-selected (thin ring)
 *       - Rewrites the card's product links (image/title) so they point at
 *         the previewed color's PDP
 *       - NEVER navigates — the swatch is purely a preview control on mobile
 *     Tap on the image or title = navigates to the currently-previewed color
 *     Tap outside the card = clears the preview
 *
 *   Mouse / pen
 *     Click navigates (existing theme behavior preserved)
 *     stopPropagation prevents the theme's <product-siblings> from
 *     double-firing productLinks[0].click()
 *
 * Works for both swatch families used on Leorana:
 *   - Sibling swatches (Etam, Puma): <a data-sibling-link> — reuses the
 *     theme's showSibling() via a synthesized mouseenter (it handles
 *     image swap + price + cutline + link rewrite)
 *   - Variant swatches (Mango, PUMA, etc.): <div data-swatch-button>
 *     containing <a data-swatch-link> — we toggle .is-visible on the
 *     matching [data-variant-title] layer (pre-rendered by
 *     product-grid-item.liquid) and rewrite the card anchors ourselves.
 */
;(function () {
  'use strict';
  if (window.__leoranaSwatchTap) return;
  window.__leoranaSwatchTap = true;

  // --- Live touch/hover gate ---
  // Evaluated at each interaction instead of once at init — avoids any chance
  // of a stale matchMedia read. We also track lastPointerType below so we can
  // respect per-interaction input mode (a user on a 2-in-1 who just tapped).
  function isTouchNow() {
    try {
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return true;
    } catch (e) { /* ignore */ }
    if ('ontouchstart' in window) return true;
    if ((navigator.maxTouchPoints || 0) > 0) {
      try {
        if (window.matchMedia && window.matchMedia('(hover: hover)').matches) return false;
      } catch (e) { /* ignore */ }
      return true;
    }
    return false;
  }
  var lastPointerType = '';
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType) lastPointerType = e.pointerType;
  }, true);
  document.addEventListener('touchstart', function () {
    lastPointerType = 'touch';
  }, { capture: true, passive: true });
  function isTouchInteraction() {
    if (lastPointerType === 'touch' || lastPointerType === 'pen') return true;
    if (lastPointerType === 'mouse') return false;
    return isTouchNow();
  }

  // --- Image-thumbnail swatches (patterned / fallback-grey only) ---
  // The theme renders each swatch fill as `background: var(--color-name,
  // #ccc)`. For solid-color swatches (black, red, navy) the CSS variable
  // resolves and the chip looks correct — leave them alone.
  //
  // But for patterned or printed products, or swatches whose color name
  // has no CSS variable (e.g. "snow-white-gwen", "birch-mille",
  // "pumice-stone-binne"), the fill silently falls back to #ccc grey —
  // shoppers see a row of identical grey chips. For THOSE swatches
  // ONLY, replace the fill with a 50x50 center-cropped thumbnail of the
  // sibling's featured image so the variant is actually recognizable.
  //
  // Detection: compute the fill's background-color BEFORE overriding. If
  // it equals rgb(204,204,204) (the #ccc fallback), we know the CSS
  // variable was undefined — swap in the image. Otherwise keep the chip.
  function buildThumbUrl(src) {
    if (!src) return '';
    var url = (src.indexOf('//') === 0) ? 'https:' + src : src;
    try {
      var u = new URL(url, location.origin);
      u.searchParams.set('width', '50');
      u.searchParams.set('height', '50');
      u.searchParams.set('crop', 'center');
      return u.toString();
    } catch (e) { return url; }
  }

  function needsImageFill(color) {
    // Replace fill with product image when the theme's color chip can't
    // represent the variant meaningfully:
    //   (a) rgb(204, 204, 204) — the #ccc fallback (CSS var undefined)
    //   (b) fully transparent — CSS var is defined to empty/transparent
    // Everything else (real solid colors) keeps its chip.
    if (!color) return true;
    var s = color.replace(/\s+/g, '');
    if (s === 'transparent') return true;
    var mRgba = s.match(/^rgba\((\d+),(\d+),(\d+),([\d.]+)\)$/i);
    if (mRgba && parseFloat(mRgba[4]) === 0) return true;
    var m = s.match(/^rgba?\((\d+),(\d+),(\d+)/i);
    if (!m) return false;
    return m[1] === '204' && m[2] === '204' && m[3] === '204';
  }

  function applyThumbs(root) {
    var scope = root || document;
    scope.querySelectorAll('a[data-sibling-image]').forEach(function (a) {
      var src = a.getAttribute('data-sibling-image');
      if (!src) return;
      var fill = a.querySelector('.grid-sibling-thumb__color') || a.firstElementChild;
      if (!fill) return;
      if (fill.dataset && fill.dataset.leoranaThumbed === '1') return;
      // Only replace chips where the theme's color fill is unusable —
      // undefined (#ccc fallback) or transparent. Solid-color swatches
      // keep their chip.
      var fillStyle = window.getComputedStyle(fill);
      var bg = fillStyle.backgroundColor;
      // Swatch list entries that are pattern images (url) or multi-colour
      // splits (gradient) have their own background-image: keep them.
      var hasOwnImage = fillStyle.backgroundImage && fillStyle.backgroundImage !== 'none';
      if (hasOwnImage || !needsImageFill(bg)) {
        if (fill.dataset) fill.dataset.leoranaThumbed = '1'; // mark as checked so we don't re-probe
        return;
      }
      var url = buildThumbUrl(src);
      // Shorthand `background` wins over the theme's inline
      // `background: var(--color-name, #ccc)`. #eee fallback shows if the
      // thumbnail fails to load — never grey-on-grey invisible.
      fill.style.background = 'url("' + url + '") center/cover no-repeat #eee';
      fill.style.backgroundSize = 'cover';
      fill.style.backgroundPosition = 'center';
      fill.style.backgroundRepeat = 'no-repeat';
      if (fill.dataset) fill.dataset.leoranaThumbed = '1';
    });
  }

  // --- Selected-state indicator (scoped, minimal, additive) ---
  // Covers every swatch variant we know the theme renders:
  //   a[data-sibling-link] .swatches .grid-sibling-thumb .swatch__button
  //   [data-swatch-button] a[data-swatch-link]
  // And the catch-all `.is-selected` inside a previewing card.
  //
  // The indicator is a LARGE centered filled circle (~60% of the swatch area)
  // with a white fill and a thin dark ring so it reads clearly on any color
  // swatch — black, white, light, dark, or patterned. A ::before halo
  // desaturates the swatch margin subtly so the centerpiece really pops.
  var SEL_PREFIX = '[data-grid-item].leorana-tap-preview ';
  var SEL_LIST = [
    'a[data-sibling-link].is-selected',
    'a.grid-sibling-thumb.is-selected',
    'a.swatches.is-selected',
    '.swatch__button.is-selected',
    '[data-swatch-button].is-selected',
    '[data-swatch-button] a[data-swatch-link].is-selected',
    '.is-selected[data-sibling-link]',
    '.is-selected[data-swatch-button]'
  ].map(function (s) { return SEL_PREFIX + s; }).join(',');

  var style = document.createElement('style');
  style.textContent =
    SEL_LIST + '{position:relative;}' +
    SEL_LIST.split(',').map(function (s) { return s + '::after'; }).join(',') + '{' +
      'content:"";position:absolute;' +
      'top:50%;left:50%;' +
      'transform:translate(-50%,-50%);' +
      'width:60%;height:60%;' +
      'border-radius:50%;' +
      'background:#fff;' +
      'box-shadow:0 0 0 1.5px rgba(0,0,0,.85), 0 1px 2px rgba(0,0,0,.25);' +
      'pointer-events:none;' +
    '}';
  (document.head || document.documentElement).appendChild(style);

  // --- Helpers ---
  function appendVariantToHref(href, variantId) {
    if (!href) return href;
    if (/variant=/.test(href)) return href.replace(/(variant=)[^&]+/, '$1' + variantId);
    return href + (/\?/.test(href) ? '&' : '?') + 'variant=' + variantId;
  }

  function clearSelection(card) {
    card.querySelectorAll('.is-selected').forEach(function (el) {
      el.classList.remove('is-selected');
    });
  }

  function rewriteCardLinks(card, newHref, skip) {
    // Rewrite every product anchor inside the card so a subsequent tap on the
    // image or title opens the previewed color. Skip swatches themselves.
    card.querySelectorAll('a[href]').forEach(function (a) {
      if (a === skip) return;
      if (a.hasAttribute('data-sibling-link')) return;
      if (a.matches('[data-swatch-link]')) return;
      if (a.closest('[data-swatch-button]')) return;
      if (a.closest('product-siblings')) return;
      var h = a.getAttribute('href');
      if (!h) return;
      if (h.indexOf('/products/') === -1 && h.indexOf('?variant=') === -1) return;
      a.setAttribute('href', newHref);
    });
    card.querySelectorAll('[data-product-link]').forEach(function (el) {
      el.setAttribute('data-product-link', newHref);
    });
  }

  function previewVariant(card, swatch) {
    var layers = card.querySelectorAll('[data-variant-title]');
    layers.forEach(function (l) { l.classList.remove('is-visible'); });
    var colorValue = swatch.getAttribute('data-color-value') ||
                     swatch.getAttribute('data-tooltip') || '';
    if (colorValue) {
      var needle = colorValue.toLowerCase();
      var match = null;
      layers.forEach(function (l) {
        if (match) return;
        var vt = (l.getAttribute('data-variant-title') || '').toLowerCase();
        if (vt.indexOf(needle) !== -1) match = l;
      });
      if (match) match.classList.add('is-visible');
    }
    var variantId = swatch.getAttribute('data-variant-id');
    if (variantId) {
      var swatchLink = swatch.querySelector('a[data-swatch-link]');
      var productBase = null;
      // Prefer a data-product-link as the base — strip any existing ?variant=
      var firstProdLink = card.querySelector('[data-product-link]');
      if (firstProdLink) {
        productBase = firstProdLink.getAttribute('data-product-link');
      } else if (swatchLink) {
        productBase = swatchLink.getAttribute('href');
      }
      if (productBase) {
        var clean = productBase.replace(/([?&])variant=[^&]*/g, '').replace(/\?&/, '?').replace(/[?&]$/, '');
        var newHref = appendVariantToHref(clean, variantId);
        rewriteCardLinks(card, newHref, swatchLink);
      }
    }
  }

  function previewSibling(card, swatch) {
    // 1) Trigger the theme's <product-siblings> handler — it does the heavy
    //    lifting: image-sibling swap, price, cutline, and href rewrites.
    try {
      swatch.dispatchEvent(new MouseEvent('mouseenter', { bubbles: true, cancelable: true }));
    } catch (err) { /* no-op */ }

    // 2) Belt-and-suspenders: rewrite the card's product links ourselves using
    //    the swatch's own data-sibling-link. Safe to do even if the theme's
    //    handler already updated them — we set the same value.
    var newHref = swatch.getAttribute('data-sibling-link') || swatch.getAttribute('href');
    if (newHref) rewriteCardLinks(card, newHref, swatch);
  }

  function resetCard(card) {
    clearSelection(card);
    card.classList.remove('leorana-tap-preview');
    card.classList.remove('is-active');
    card.querySelectorAll('[data-variant-title].is-visible').forEach(function (l) {
      l.classList.remove('is-visible');
    });
    var sibImg = card.querySelector('[data-product-image-sibling]');
    if (sibImg) {
      sibImg.classList.remove('is-visible');
      sibImg.querySelectorAll('img').forEach(function (i) { i.classList.remove('is-fade'); });
    }
  }

  // --- Desktop: restore hrefs on swatch anchors.
  //     The Liquid snippet renders swatches WITHOUT href (so mobile tap
  //     has nothing to navigate to — pure preview). On desktop we want
  //     native click + cmd-click (new tab) + middle-click to work, so
  //     we re-add the href from data-sibling-link whenever a mouse-like
  //     pointer is present. On touch-only devices, we leave it blank.
  var DESKTOP_MQ = (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)')) || { matches: false, addEventListener: function(){}, addListener: function(){} };

  function restoreDesktopHref(a) {
    if (!a) return;
    if (!DESKTOP_MQ.matches) return;
    var link = a.getAttribute('data-sibling-link') || a.getAttribute('data-swatch-link');
    if (!link) return;
    if (a.getAttribute('href') !== link) a.setAttribute('href', link);
  }

  function stripHrefForTouch(a) {
    // If device is touch-only, make sure there's no href (belt-and-braces
    // in case a stray href sneaks in from theme templates).
    if (!a) return;
    if (DESKTOP_MQ.matches) return;
    if (a.hasAttribute('href')) a.removeAttribute('href');
    if (!a.hasAttribute('role')) a.setAttribute('role', 'button');
    if (!a.hasAttribute('tabindex')) a.setAttribute('tabindex', '0');
  }

  function applyToAll(root) {
    var scope = root || document;
    scope.querySelectorAll('a[data-sibling-link]').forEach(function (a) {
      if (DESKTOP_MQ.matches) restoreDesktopHref(a);
      else stripHrefForTouch(a);
    });
    scope.querySelectorAll('[data-swatch-button] a[data-swatch-link]').forEach(function (a) {
      if (DESKTOP_MQ.matches) restoreDesktopHref(a);
      else stripHrefForTouch(a);
    });
  }

  function swatchTargetHref(swatch) {
    if (swatch.matches && swatch.matches('a[data-sibling-link]')) {
      return swatch.getAttribute('href') ||
             swatch.getAttribute('data-sibling-link') || '';
    }
    var a = swatch.querySelector && swatch.querySelector('a[data-swatch-link]');
    if (a) return a.getAttribute('href') || a.getAttribute('data-swatch-link') || '';
    return '';
  }

  // Run now + on every future mutation. Also re-run if the media query flips
  // (e.g. user plugs in a mouse on a 2-in-1, or rotates a tablet that
  // changes hover capability).
  applyToAll(document);
  applyThumbs(document);
  if (typeof DESKTOP_MQ.addEventListener === 'function') {
    DESKTOP_MQ.addEventListener('change', function () { applyToAll(document); });
  } else if (typeof DESKTOP_MQ.addListener === 'function') {
    DESKTOP_MQ.addListener(function () { applyToAll(document); });
  }
  if (typeof MutationObserver === 'function') {
    var mo = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('a[data-sibling-link]')) {
            if (DESKTOP_MQ.matches) restoreDesktopHref(n); else stripHrefForTouch(n);
            applyThumbs(n.parentNode || n);
          } else if (n.matches && n.matches('[data-swatch-button] a[data-swatch-link]')) {
            if (DESKTOP_MQ.matches) restoreDesktopHref(n); else stripHrefForTouch(n);
          } else if (n.querySelectorAll) {
            applyToAll(n);
            applyThumbs(n);
          }
        }
      }
    });
    mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  // --- Main tap/click interceptor (capture phase) ---
  // On TOUCH: preventDefault + stopImmediatePropagation — kills both native
  //   navigation and the theme's forwarded click. Preview only.
  // On DESKTOP (mouse/pen): stopPropagation (kills theme's duplicate
  //   productLinks[0].click()) but NO preventDefault — so native anchor
  //   navigation still runs, and cmd-click / middle-click work as expected.
  function onSwatchClick(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var siblingSwatch = t.closest('a[data-sibling-link]');
    var variantSwatch = t.closest('[data-swatch-button]');
    var swatch = siblingSwatch || variantSwatch;
    if (!swatch) return;

    var card = swatch.closest('[data-grid-item]');
    if (!card) return;

    var touch = isTouchInteraction();

    // Kill the theme's duplicate click forward on every device.
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    if (touch) {
      // Mobile: preview-only. Block navigation entirely.
      e.preventDefault();
      clearSelection(card);
      card.classList.add('leorana-tap-preview');
      if (siblingSwatch)      previewSibling(card, siblingSwatch);
      else if (variantSwatch) previewVariant(card, variantSwatch);
      swatch.classList.add('is-selected');
      return;
    }

    // Desktop / mouse / pen: let native navigation happen.
    // cmd-click / middle-click / ctrl-click open in new tab — don't
    // interfere, just let the browser do its thing.
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;

    // Regular left-click on desktop — show a brief preview selected state
    // before native navigation kicks in (often imperceptible but harmless).
    clearSelection(card);
    card.classList.add('leorana-tap-preview');
    if (siblingSwatch)      previewSibling(card, siblingSwatch);
    else if (variantSwatch) previewVariant(card, variantSwatch);
    swatch.classList.add('is-selected');
  }
  document.addEventListener('click', onSwatchClick, true);
  // Extra belt for iOS: some Safari versions can synthesize a click that
  // bypasses capture-phase listeners added late. `pointerup` gives us an
  // earlier hook to kill the event.
  document.addEventListener('pointerup', function (e) {
    if (!isTouchInteraction()) return;
    var t = e.target;
    if (!t || !t.closest) return;
    var swatch = t.closest('a[data-sibling-link], [data-swatch-button]');
    if (!swatch) return;
    // We don't run preview here (click will do it), just ensure nothing
    // else reacts to this pointerup.
    e.stopPropagation();
  }, true);

  // --- Outside tap clears preview (touch only) ---
  document.addEventListener('pointerdown', function (e) {
    if (!isTouchInteraction()) return;
    document.querySelectorAll('[data-grid-item].leorana-tap-preview').forEach(function (card) {
      if (card.contains(e.target)) return;
      resetCard(card);
    });
  }, true);
  document.addEventListener('touchstart', function (e) {
    document.querySelectorAll('[data-grid-item].leorana-tap-preview').forEach(function (card) {
      if (card.contains(e.target)) return;
      resetCard(card);
    });
  }, { capture: true, passive: true });
})();
